import {
  H4,
  P,
  QuickActionButton,
} from 'base-components';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'lingui-react';
import {
  Container,
  Row,
  Column,
} from 'styled-components-reactive-grid';

import SelectedLabel from './SelectedLabel';
import messages from './messages';

function ServiceProvider({
  isSelected,
  onSelect,
  serviceProvider,
}) {
  const {
    address: {
      city,
      postalCode,
      region,
      street,
      street2,
    },
    companyName,
  } = serviceProvider;

  return (
    <Container className="ServiceProvider" modifiers={['padScaleY_4']}>
      <Row modifiers={['middle']}>
        <Column modifiers={['col']}>
          <H4>
            {companyName}
          </H4>
        </Column>
        <Column modifiers={['col', 'end']}>
          {isSelected ?
            <SelectedLabel /> :
            <QuickActionButton
              modifiers={['hoverSuccess']}
              onClick={() => onSelect(serviceProvider)}
            >
              <QuickActionButton.Text>
                <Trans id={messages.select} />
              </QuickActionButton.Text>
            </QuickActionButton>
          }
        </Column>
      </Row>
      <Row>
        <Column modifiers={['col_12', 'padScaleY_0']}>
          <P>
            {`${street} ${street2}`}
          </P>
        </Column>
        <Column modifiers={['col_12', 'padScaleY_0']}>
          <P>
            {`${city}, ${region} ${postalCode}`}
          </P>
        </Column>
      </Row>
    </Container>
  );
}

ServiceProvider.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  serviceProvider: PropTypes.shape({
    address: PropTypes.shape({
      city: PropTypes.string,
      postalCode: PropTypes.string,
      region: PropTypes.string,
      street: PropTypes.string,
      street2: PropTypes.string,
    }).isRequired,
    companyName: PropTypes.string,
  }).isRequired,
};

export default ServiceProvider;



// WEBPACK FOOTER //
// ./components/ServiceProvidersList/ServiceProvider.js